import React from 'react';

import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from 'assets/icons/x.svg';

import './Modal.scoped.scss';

const modalElement = document.getElementById('modal');

interface Props {
  children?: React.ReactNode;
  open: boolean;
  fullScreen?: boolean;
  removeCloseIcon?: boolean;
  maxWidth?: string | number;
  padding?: string | number;
  marginTop?: string | number;
  onClose?: () => void;
  title?: string;
}

const Modal: React.FC<Props> = ({
  open,
  fullScreen,
  removeCloseIcon = false,
  maxWidth,
  onClose,
  children,
  title,
  padding,
  marginTop,
}) => {
  const handleClose = () => {
    if (onClose) onClose();
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className="modal-container max-height">
      <div className="backdrop" onClick={handleClose} />

      <div
        className={`modal ${fullScreen && 'full-screen'}`}
        style={{ maxWidth, padding, marginTop }}
      >
        <div className="title-close-container">
          <div className="title">
            <h3>{title}</h3>
          </div>
          {!removeCloseIcon && (
            <div className="close-icon" onClick={handleClose}>
              <CloseIcon style={{ width: 30 }} />
            </div>
          )}
        </div>
        <div className="children-container">{children}</div>
      </div>
    </div>,
    modalElement!
  );
};

export default Modal;
